import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const CreateBranch = ({ visible, handleClose, initialData = '', onSubmit }) => {
    const formik = useFormik({
        initialValues: {
            branchName: initialData?.branchName || '',
            branchAddress: initialData?.branchAddress || '',
        },
        validationSchema: Yup.object({
            branchName: Yup.string().required('Branch Name is required'),
            branchAddress: Yup.string().required('Branch Address is required'),
        }),
        validateOnChange: true,
        onSubmit: (values, { resetForm }) => {
            if (initialData?.branchName) {
                onSubmit({
                    sp: 'usp_UpdateBranch',
                    branchName: values?.branchName,
                    branchAddress: values?.branchAddress,
                    branchId: initialData?.branchId,
                });
            } else {
                onSubmit({
                    sp: 'usp_InsertBranch',
                    branchName: values?.branchName,
                    branchAddress: values?.branchAddress,
                });
            }
            onClose();
        },
    });

    const onClose = () => {
        formik.resetForm();
        handleClose();
    };

    useEffect(() => {
        if (initialData) {
            formik.setValues(
                {
                    branchName: initialData.branchName || '',
                    branchAddress: initialData.branchAddress || '',
                },
                false // Prevent validation from running
            );
        }
    }, [initialData]);

    return (
        <Modal
            title={initialData ? 'Edit Branch' : 'Create New Branch'}
            visible={visible}
            onCancel={onClose}
            footer={null}
            destroyOnClose
            centered
            width={600}
            className="custom-modal-header p-0"
            maskClosable={false}
        >
            <form onSubmit={formik.handleSubmit}>
                <div role="document">
                    <div className="row g-3">
                        <div className="col-md-12">
                            <label className="form-label fs-7 text-light-emphasi">
                                Branch Name
                            </label> <span className='text-danger'>*</span>
                            <input
                                type="text"
                                className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                                placeholder="Enter Branch Name"
                                name="branchName"
                                value={formik.values.branchName}
                                onChange={formik.handleChange}
                            />
                            {formik.touched.branchName && formik.errors.branchName && (
                                <span style={{ color: 'red' }} role="alert">{formik.errors.branchName}</span>
                            )}
                        </div>

                        <div className="col-md-12 mt-3">
                            <label className="form-label fs-7 text-light-emphasi">
                                Branch Address
                            </label> <span className='text-danger'>*</span>
                            <input
                                type="text"
                                className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                                placeholder="Enter Branch Address"
                                name="branchAddress"
                                value={formik.values.branchAddress}
                                onChange={formik.handleChange}
                            />
                            {formik.touched.branchAddress && formik.errors.branchAddress && (
                                <span style={{ color: 'red' }} role="alert">{formik.errors.branchAddress}</span>
                            )}
                        </div>
                    </div>

                    <div className="modal-footer mt-3">
                        <button type="button" className="btn btn-light" onClick={onClose}>
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary ms-3">
                            {initialData ? 'Update' : 'Add'}
                        </button>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

export default CreateBranch;
